<template>
  <div
    class="sn-select-display"
    :class="{
      'small': !tall
    }"
    :style="innerWidth"
    @click="toggle"
  >
    <component
      :is="displayComponents.single[displayType]"
      v-if="settings.singleSelect"
      class="default-display"
      :value="firstValue"
      :settings="settings"
    />

    <component
      :is="displayComponents.multi[displayType]"
      v-if="!settings.singleSelect"
      class="current-selection"
      :value="activeValue"
      :settings="settings"
      @optionSelected="optionSelected"
    />

    <p4a-icon
      class="select-icon right"
      icon="select-small"
      :color="disabled ? 'lightgray' : '#58586a'"
    />

    <span
      class="selection-length right"
      v-if="singleSelect === false"
      v-text="activeCount"
    />
  </div>
</template>

<script>
  import _ from 'lodash'

  import Locales from '../../../../localization/Locales'

  import DisplayTemplateSingleDefault from './display-templates/default/DisplayTemplateSingleDefault'
  import DisplayTemplateMultiDefault from './display-templates/default/DisplayTemplateMultiDefault'

  import DisplayTemplateSingleUser from './display-templates/user/DisplayTemplateSingleUser'

  export default {
    name: 'SNSelectDisplay',
    components: {
    },

    i18n: {
      messages: Locales
    },

    data () {
      return {
        displayComponents: {
          single: {
            default: DisplayTemplateSingleDefault,
            user: DisplayTemplateSingleUser
          },
          multi: {
            default: DisplayTemplateMultiDefault,
            user: DisplayTemplateMultiDefault
          }
        }
      }
    },
    props: {
      value: {
        default: function () {
          return []
        },
        type: Array
      },
      disabled: {
        default: false,
        type: Boolean
      },
      selectionWidth: {
        default: 275,
        type: Number
      },
      settings: {
        default: function () {
          return {}
        },
        type: Object
      }
    },
    methods: {
      optionSelected (value) {
        let self = this
        self.$emit('optionSelected', value)
      },
      toggle () {
        let self = this
        if (!self.disabled) {
          self.$emit('toggle')
        }
      },
      selectionText (option) {
        let self = this
        let result = option[self.label]
        if (!self.tall && !self.singleSelect) {
          result += ','
        }
        return result
      },
      selectionColor (option) {
        let result = null
        if (option.Color) {
          result = {
            'background-color': '#' + option.Color
          }
        }
        return result
      }
    },
    computed: {
      displayType () {
        let self = this
        let result = 'default'

        if (self.settings.displayType) {
          result = self.settings.displayType
        }

        return result
      },
      activeValue () {
        let self = this
        let result = _.filter(self.value, { 'selected': true })
        return result
      },
      firstValue () {
        let self = this
        let result = null

        if (self.activeCount > 0) {
          result = _.first(self.activeValue)
        }

        return result
      },
      tall () {
        return this.settings.tall
      },
      singleSelect () {
        return this.settings.singleSelect
      },
      selectionHeight () {
        return this.tall ? 50 : 25
      },
      innerWidth () {
        return {
          'width ': this.selectionWidth - 2 + 'px',
          'height': this.selectionHeight + 'px'
        }
      },
      activeCount () {
        let self = this
        return _.size(self.activeValue)
      }
    }
  }
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../../uikit';

  .sn-select-display {

    .default-display {
      width: calc(100% - 50px);
      display: inline-block;
    }

    .current-selection {
      width: calc(100% - 70px);
      display: inline-block;
    }

    .selection-length {
      height: 100%;
      line-height: 50px;
      font-size: 14px;
    }

    .select-icon {
      height: 100%;
      padding: 18px;
      width: 50px;
    }

    &.small {
      .default-display {
        width: calc(100% - 25px);
      }

      .current-selection {
        width: calc(100% - 35px);
      }

      .selection-length {
        height: 100%;
        line-height: 25px;
        font-size: 14px;
      }

      .select-icon {
        padding: 7px;
        width: 25px;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/input-templates/selection/SNSelectDisplay.vue